import {useEffect} from 'react';
import Toast from 'react-native-toast-message';

import {ERROR_MESSAGE} from '../../../components/ToastBottom';
import {AppRoute} from '../../../models/AppRoute';
import {CartStore} from '../../../stores/cartStore';
import {PaymentStore} from '../../../stores/paymentStore';
import {useStores} from '../../../stores/use-stores';
import {UserStore} from '../../../stores/userStore';

const getPlaceOrderValidationError = ({
  cartStore,
  paymentStore,
  userStore,
}: {
  cartStore: CartStore;
  paymentStore: PaymentStore;
  userStore: UserStore;
}) => {
  if (!cartStore.currentOrder?.order_lines) {
    return 'Cannot place an empty order';
  }

  if (!userStore.billingAddress) {
    return 'Please set a Billing Address';
  }

  if (!cartStore.selectedSlot) {
    return 'To place your order please select a delivery or pick up time.';
  }

  if (cartStore.hasNominatedPerson && !cartStore.nominatedPersonName.length) {
    return 'A person (18+) must be nominated to accept the delivery';
  }

  // Payment methods and gift cards
  const isGiftCardsBeingUsed = cartStore.isGiftCardsBeingUsed();
  const isGiftCardsNotCoveringTotal =
    cartStore.getTotalChargedOnGiftCardsCents() < cartStore.totalAmount;
  const isCreditCardAvailable = paymentStore.tillUserPaymentInstrument;
  if (
    isGiftCardsBeingUsed &&
    isGiftCardsNotCoveringTotal &&
    !isCreditCardAvailable
  ) {
    return "The gift cards do not cover the total amount and there's no other payment method available. Please add a debit/credit card";
  }

  return null;
};

const handleContinue =
  ({
    callback,
    cartStore,
    paymentStore,
    userStore,
  }: {
    callback: () => void;
    cartStore: CartStore;
    paymentStore: PaymentStore;
    userStore: UserStore;
  }) =>
  () => {
    const error = getPlaceOrderValidationError({cartStore, paymentStore, userStore});

    if (error) {
      console.log('☠️', error);
      Toast.show({
        type: ERROR_MESSAGE,
        text1: error,
      });
    } else {
      callback?.();
    }
  };

/**
 * Redirect to cart screen if order is empty
 * @param navigation
 */
const useRedirectEmptyCart = (navigation: any) => {
  const {cartStore} = useStores();

  useEffect(() => {
    if (!cartStore.isLoadingOrder && !cartStore.currentOrder?.order_lines) {
      navigation.navigate(AppRoute.ROOT, {
        screen: AppRoute.MAIN,
        params: {screen: AppRoute.CART},
      });
    }
  }, [
    cartStore.currentOrder?.order_lines,
    cartStore.isLoadingOrder,
    navigation,
  ]);
};

export {getPlaceOrderValidationError, handleContinue, useRedirectEmptyCart};
